import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ClerkProvider } from '@clerk/clerk-react';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { initLinkedInInsight } from './lib/linkedinInsight';

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing Clerk Publishable Key');
}

// PostHog product analytics. Loads through the /ingest reverse proxy (see
// vercel.json) so ad-blockers don't drop events. person_profiles:'identified_only'
// keeps anonymous events but only creates person profiles for signed-in users
// (cost-friendly). Session replay masks all text inputs for privacy. If the key
// is absent (e.g. local dev), posthog.capture is a safe no-op.
const POSTHOG_KEY = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_PUBLIC_POSTHOG_HOST || '/ingest';
if (POSTHOG_KEY) {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    ui_host: 'https://us.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
    autocapture: true,
    session_recording: { maskAllInputs: true },
    persistence: 'localStorage+cookie',
  });
}

// No-op unless REACT_APP_LINKEDIN_PARTNER_ID is set.
initLinkedInInsight();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
        <App />
      </ClerkProvider>
    </PostHogProvider>
  </React.StrictMode>
);
